import { render, staticRenderFns } from "./MitActionNewPersonWizardPage.vue?vue&type=template&id=7df55962&scoped=true"
import script from "./MitActionNewPersonWizardPage.vue?vue&type=script&lang=js"
export * from "./MitActionNewPersonWizardPage.vue?vue&type=script&lang=js"
import style0 from "./MitActionNewPersonWizardPage.vue?vue&type=style&index=0&id=7df55962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df55962",
  null
  
)

export default component.exports